import { useCallback, useEffect, useState } from 'react';
import { get } from './api.ts';

/** GET `url` (null = skip) with loading/error state and a reload(). */
export function useData<T>(url: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(!!url);
  const reload = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    setError(null);
    try {
      setData(await get<T>(url));
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [url]);
  useEffect(() => { void reload(); }, [reload]);
  return { data, error, loading, reload, setData };
}
